
import { Link } from 'react-router-dom';

interface Article {
  id: string;
  title: string;
  category: string;
  source: string;
  date: string;
  timeAgo: string;
  image: string;
  isBreaking?: boolean;
  location?: string;
}

export default function NewsArticleHero({ article }: { article: Article }) {
  if (!article?.title || !article?.image) {
    return null;
  }

  return (
    <div className="relative pt-20">
      <div className="relative h-[420px] overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20" />

        <div className="absolute bottom-0 left-0 right-0 p-8">
          <div className="max-w-4xl mx-auto">
            {/* Breadcrumb */}
            <nav className="flex items-center gap-2 text-sm text-white/60 mb-4">
              <Link to="/" className="hover:text-white transition-colors cursor-pointer">Home</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <Link to="/news" className="hover:text-white transition-colors cursor-pointer">News</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-white/80">{article.category}</span>
            </nav>

            <div className="flex items-center gap-3 mb-4">
              {article.isBreaking && (
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-red-600 text-white text-xs font-bold rounded-full animate-pulse whitespace-nowrap">
                  <span className="w-1.5 h-1.5 bg-white rounded-full"></span>
                  BREAKING
                </span>
              )}
              <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs font-medium rounded-full whitespace-nowrap">
                {article.category}
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-3">
              {article.title}
            </h1>

            <div className="flex flex-wrap items-center gap-4 text-white/60 text-sm">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-time-line"></i>
                {article.timeAgo}
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-calendar-line"></i>
                {new Date(article.date).toLocaleDateString('en-US', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </span>
              {article.location && (
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-map-pin-line"></i>
                  {article.location}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
